export const ChartWithNoAxesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-chart-no-axes-column-increasing-icon lucide-chart-no-axes-column-increasing'
    {...props}
  >
    <path d='M5 21v-6' />
    <path d='M12 21V9' />
    <path d='M19 21V3' />
  </svg>
)
